<template>
  <!--<div class="menu">-->
  <el-container>
    <!--侧边栏-->
    <el-aside >
        <el-col class="menu" >
    <!-- <h5>默认颜色</h5> -->
    <el-menu
      background-color="#e0e3e8"
      default-active="2"
      class="el-menu-vertical-demo"
      @open="handleOpen"
      router=true
      @close="handleClose">
      <el-submenu index="1">
        <template slot="title">
          <i class="el-icon-location"></i>
          <span>培训资料管理</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="courseInfoList">课程列表</el-menu-item>
          <el-menu-item index="dirManagement">目录管理</el-menu-item>
          <el-menu-item index="readInfoList">阅读信息管理</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <!-- <el-menu-item index="2">
        <i class="el-icon-menu"></i>
        <span slot="title">导航二</span>
      </el-menu-item>
      <el-menu-item index="3" disabled>
        <i class="el-icon-document"></i>
        <span slot="title">导航三</span>
      </el-menu-item>
      <el-menu-item index="4">
        <i class="el-icon-setting"></i>
        <span slot="title">导航四</span>
      </el-menu-item> -->
    </el-menu>
  </el-col>

    </el-aside>
  </el-container>

  <!--</div>-->
</template>

<script>
// 导入n3导航插件
export default {
  //        引入相关模板
  name: 'Sidebar',
  //        初始化定义变量
  data () {
    return {
      sidebar_active: '',
      team_hide: true,
      sale_hide: true,
      message_hide: true,
      getTeamTreeReq: {
        agentNum: '62001554',
        level: 'T'
      },
      teamTree: [],
      activeName: '',
      teamCode: ''
    }
  },
  /*
     * 在模板渲染成html后调用，
     * 通常是初始化页面完成后，
     * 再对html的dom节点进行一些需要的操作。
     * */
  mounted () {
    // this.getTeamTree()
  },
  // 方法集
  methods: {

    handleOpen (key, keyPath) {
      // key:当前点击菜单index
      // keyPath: 当前点击菜单及其父菜单的级联index
      // 判断是第几个 团队树
      // var ins = keyPath[0]
      // var route = ''
      // if (ins === '1') {
      //   route = 'teamInfo'
      // } else if (ins === '2') {
      //   route = 'teamAssess'
      // } else if (ins === '3') {
      //   route = 'teamConRate'
      // }
      // var info = key
      // var teamCode = info.substring(0, info.indexOf('-'))
      // var agentNum = info.substring(info.indexOf('-') + 1)
      // this.$router.push({name: route, query: {pid: agentNum, teamCode: teamCode}})
    },
    handleClose (key, keyPath) {
      // console.log(key, keyPath)
    }

  },
  //        实时监控路由改变就执行
  watch: {}
}
</script>

<style scoped>
  .menu{
    /* min-height: calc(100% - 100px); */
    min-height:400px;
    border: none;
    background: #e0e3e8;
    position: absolute;
    top:80;
    left: 30;
   width: 15%;
    margin: 0 1%;
  }
.el-submenu .el-menu-item {
  min-width: 100px;
}
  .menu-item{
    text-align: center;
    padding:20px 0;
  }
  .menu-item img{
    width: 100%
  }
  .team_hide,.sale_hide,.message_hide{
    display: none;
  }
  .photo-div{
    width: 100%;
    text-align: center;
    padding:10px 0;
  }
 .title-detail{
   font-size:12px;
 }
  .blue .active{
    background-color: #002D76;
  }
  .active{
    background-color: #fff;
  }
  .sale-model{
    /*background-color: #002D76;*/
    height:100%;
    min-width: 200px;
    position:absolute;
    top:0;
    left: 100%;
    z-index:999;
}
.menu-item {
  text-align: center;
  padding: 10px 0;
}
.menu-item img {
  width: 35%
}
.sale-model span,
.sale-model li,
.sale-model div {
  color: #5876b9;
}
.sale-model h4 {
  text-align: center;
}
.sale-model ul {
  border: none;
}
.sale-model h1{
  text-align: center;
  font-size:18px;
  color:rgba(153,153,153,1);
  height: 102px;
  line-height: 130px;
}
.coll-item{
  text-align: center
}
.el-collapse-item__header {
    height: 95px;
    line-height: 95px;
    background: red;
}
   /* @media screen and (max-width: 1024px) {
    .menu{
      font-size: 14px;
    }
    .title-detail{
      font-size:12px;
    }
  }
  @media screen and (min-width: 1400px) {
    .menu-item {
      padding: 15px 0;
    }
    .menu{
      width:8%;
    }
  }
  @media screen(min-width: 1024px) and (max-width: 1400px) {
    .menu-item {
      padding: 15px 0;
    }
  } */
</style>



// WEBPACK FOOTER //
// src/layout/BackendSidebar.vue